// extracted by mini-css-extract-plugin
export default {"container":"rqqXi","item":"ygRAk","item-extended":"b1s7s","icon":"MMxMg","inline":"g93lu"};